import React, { DispatchWithoutAction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { convertBaggageObject } from '../../../Checkout/types';
import { GdsServicesWithPurchasePredictions_OrderAdditionalServiceGdsServiceBaggage_Fragment } from '@websky/graphql';
import BaggageIcon from '../../../Baggage/Baggage/components/BaggageIcon/BaggageIcon';
import UpsaleItem from '@features/upsale/ui/UpsaleItem/UpsaleItem';
import AiPredictionFooter from '../AiPredictionFooter/AiPredictionFooter';

interface Props {
	item: GdsServicesWithPurchasePredictions_OrderAdditionalServiceGdsServiceBaggage_Fragment;
	onAgree: DispatchWithoutAction;
	onChange: DispatchWithoutAction;
	onDisagree: DispatchWithoutAction;
}

const AiPurchasePredictionBaggage: React.FC<Props> = ({ item, onChange, onDisagree, onAgree }) => {
	const { t } = useTranslation('AIPurchasePredictionService');

	const baggage = useMemo(() => {
		return convertBaggageObject(item);
	}, [item]);

	const service = useMemo(() => ({
		price: baggage.price,
		name: baggage.name,
		header: <BaggageIcon realSize={true} baggage={baggage} />,
		description: <span>{baggage.description}</span>
	}), [baggage]);

	return (
		<>
			<UpsaleItem
				title={t('Looks like you forgot to add your baggage')}
				service={service}
				onChange={onChange}
				footer={
					<AiPredictionFooter
						text={t('Continue without baggage')}
						onDisagree={onDisagree}
						onAgree={onAgree}
					/>
				}
			/>
		</>
	);
};

export default AiPurchasePredictionBaggage;
